/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { bignumberDependencies } from './dependenciesBignumber.generated';
import { fractionDependencies } from './dependenciesFraction.generated';
import { numberDependencies } from './dependenciesNumber.generated';
import { createNumeric } from '../../factoriesAny.js';
export var numericDependencies = {
  bignumberDependencies: bignumberDependencies,
  fractionDependencies: fractionDependencies,
  numberDependencies: numberDependencies,
  createNumeric: createNumeric
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesNumeric.generated.js
// module id = 227
// module chunks = 0